import httpService from '@services/httpService'

export const fields = [
  'name', 'active'
]

export const validate = values => {
  const requiredFields = [
    'name',
    'description_pt',
    'description_en',
    'description_es'
  ]
  const errors = {}

  requiredFields.forEach(field => {
    if (!values[field]) errors[field] = I18n.t('validations.required')
  })

  return errors
}

export const getPrivacyPolicyHeaders = () =>
  fields.map(field => ({
    title: I18n.t(`activerecord.attributes.v4/terms.${field}`),
    field,
    render: rowData =>
      field === 'active'
        ? I18n.t(`activerecord.attributes.v4/terms.status_${rowData['active'].toString()}`)
        : rowData[field]
  }))


export const privacyPolicyActionsHandler = (id, apiRequest, handleError, o) => async () => {
  const actionUrl = `/admin/privacy_policies/${id}/activate`

  await apiRequest
    .patch(actionUrl)
    .then(() =>
      Turbolinks.visit(`/v4/o/${o}/admin/privacy_policies`)
    )
    .catch((error) =>
      handleError(error)
    )
}
